import React, {useEffect, useState} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider
} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {spaceBottomStyle} from './RecordDetailsDialogStyle';
import WithPermission from '@components/system/WithPermission/WithPermission';
import {AppPermissions} from '@shared/constants/Mapping';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSnackbar} from 'notistack';
import {getCCMPatientPlanLogRecordDetails} from '@shared/services/CCMServices';
import {TEXT_GRAY_COLOR} from 'src/style/variable';
import Loader from '@components/framework/loader/Loader';

interface EnrollmentDialogProps {
  open: boolean;
  onClose: () => void;
  patientName: string;
  accountNumber: string;
  groupId: number;
  clinicId: number | string;
  patientId: number | undefined;
  ccmPatientId: number;
  selectedRowData: any;
}
const CCMLogRecordDetailsDialog: React.FC<EnrollmentDialogProps> = ({
  open,
  onClose,
  patientName,
  accountNumber,
  groupId,
  clinicId,
  patientId,
  ccmPatientId,
  selectedRowData
}) => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const [state, setState] = useState({
    planDataList: []
  });
  const {planDataList} = state;
  const [loader, setLoader] = useState(true);
  const renderDialogTitle = () => {
    return (
      <div>
        {t('CCM.RECORD_DETAILS.RECORD_DETAILS', {patientName: patientName})}
        <strong>&nbsp;&nbsp;&bull;&nbsp;&nbsp;</strong>
        {`${accountNumber})`}
      </div>
    );
  };

  const fetchCCMPatientPlanLogDetails = async () => {
    const options: {
      // eslint-disable-next-line camelcase
      clinic_id?: string | number;
    } = {};
    if (clinicId) {
      options.clinic_id = clinicId;
    }
    try {
      const response = await getCCMPatientPlanLogRecordDetails(
        groupId,
        ccmPatientId,
        selectedRowData?.id,
        options
      );
      if (response) {
        setLoader(false);
        setState(prevState => ({
          ...prevState,
          planDataList: response?.data?.rows
        }));
      }
    } catch (err: any) {
      enqueueSnackbar(
        err.message || t('CCM.CCM_PLAN_TASK_DETAILS_FETCH_ERROR'),
        SnackBarConfig('e')
      );
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchCCMPatientPlanLogDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const renderContent = () => {
    return (
      <div>
        {!loader ? (
          <div>
            {planDataList?.length > 0 ? (
              <div style={{...spaceBottomStyle}}>
                {planDataList.map((item: any, i) => {
                  return (
                    <div style={{...spaceBottomStyle}} key={item.id}>
                      <div style={{marginBottom: '0.3rem'}}>
                        <div>{`${i + 1}. ${item.task_name}`}</div>
                        {item.response && (
                          <div
                            style={{
                              padding: '0.2rem 0 0 1.2rem',
                              color: TEXT_GRAY_COLOR
                            }}>
                            <i>{`${item.response}`}</i>
                          </div>
                        )}
                      </div>

                      <Divider />
                    </div>
                  );
                })}
              </div>
            ) : (
              t('CCM.NO_RECORD_DETAILS_ENTERED')
              // 'No task created at this time period'
            )}
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <Loader />
          </div>
        )}
      </div>
    );
  };

  const renderButtons = () => {
    return (
      <div>
        <Button
          type="submit"
          variant={'contained'}
          onClick={onClose}
          color="primary">
          {t('COMMON.CLOSE')}
        </Button>
      </div>
    );
  };
  const renderDialogContent = () => {
    return <div>{renderContent()}</div>;
  };
  return (
    <Dialog
      disableEnforceFocus
      maxWidth={'sm'}
      fullWidth={true}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      open={open}
      onClose={onClose}
      aria-labelledby="enrollment-dialog-title">
      <DialogTitle disableTypography id="enrollment-dialog-title">
        {renderDialogTitle()}
      </DialogTitle>
      <DialogContent dividers>{renderDialogContent()}</DialogContent>
      <DialogActions style={{display: 'flex'}}>{renderButtons()}</DialogActions>
    </Dialog>
  );
};
export default WithPermission(
  CCMLogRecordDetailsDialog,
  AppPermissions.CCM.NAME,
  AppPermissions.CCM.READ
);
